import { useMemo } from 'react';
import { useUserInfo } from 'marketing-platform-lib/providers/UserInfoProvider';
import { useAssetPreview } from 'framework-asset-preview-lib/internal/shared/providers/AssetPreviewProvider';
import { getAssociationConfig } from 'framework-asset-preview-lib/internal/associations/constants/associationConfig';
import { useFetchCampaignsAssociationSettings } from 'campaigns-lib/campaignsPlatform';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
export default function useCrmAssetAssociations() {
  const {
    objectType
  } = useAssetPreview();
  const {
    hasScope,
    isUngatedFor
  } = useUserInfo();
  const {
    data: fasPoweredAssociations
  } = useFetchCampaignsAssociationSettings(objectType !== OBJECT_TYPE.CAMPAIGN);
  const associationMap = useMemo(() => getAssociationConfig(objectType, fasPoweredAssociations), [fasPoweredAssociations, objectType]);
  return useMemo(() => {
    if (!associationMap) {
      return [];
    }
    return associationMap.filter(associationConfig => associationConfig.isEnabled({
      hasScope,
      isUngatedFor
    })).map(associationConfig => associationConfig.associationName);
  }, [associationMap, hasScope, isUngatedFor]);
}